import { Outlet } from 'react-router';

import { AppSidebar } from '@/components/features/app-sidebar/AppSidebar';
import { NavHeaderMobile } from '@/components/features/app-sidebar/NavHeaderMobile';
import NotificationPermissionAlert from '@/components/features/notifications/NotificationPermissionAlert';
import NotificationsSheetProvider from '@/components/features/notifications/NotificationSheetProvider';
import NotificationsSheet from '@/components/features/notifications/NotificationsSheet';
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar/Sidebar';

export default function MainView() {
  return (
    <>
      <NotificationsSheetProvider>
        <SidebarProvider className={'max-h-dvh max-w-dvw'}>
          <AppSidebar />
          <SidebarInset className={'min-h-dvh overflow-x-hidden'}>
            <NavHeaderMobile />
            <div className={'flex grow flex-col'}>
              <div className={'mx-auto flex w-full max-w-[1480px] grow flex-col gap-4'}>
                <Outlet />
              </div>
            </div>
          </SidebarInset>
        </SidebarProvider>
        <NotificationsSheet />
      </NotificationsSheetProvider>

      <NotificationPermissionAlert />
    </>
  );
}
